import styled from "styled-components";

const BurgerMenuStyled = styled.div`
  display: flex;
  align-content: center;
`;

export default BurgerMenuStyled;
